module.exports = "../static/images/3921a5.png";